import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useLocalization } from '../../contexts/LocalizationContext';
import NavMenu from './NavMenu';
import Header from './Header';
import MessageComponent from '../Common/MessageComponent';

const MainLayout = () => {
  const { getDirection } = useLocalization();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Close sidebar on every navigation event (location.key changes on every navigation)
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.key]);
  const [message, setMessage] = useState(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="admin-layout" dir={getDirection()}>
      {isMobileMenuOpen && (
        <div className="overlay active" onClick={toggleMobileMenu}></div>
      )}

      <aside className={`sidebar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        <NavMenu onLinkClick={() => setIsMobileMenuOpen(false)} />
      </aside>
      
      <div className="main-wrapper">
        <Header onMenuToggle={toggleMobileMenu} />
        
        <main className="content-area content-area-full">
          <Outlet />
        </main>
      </div>

      {message && (
        <MessageComponent
          message={message.message}
          title={message.title}
          type={message.type}
          isVisible={true}
          onClose={() => setMessage(null)}
        />
      )}
    </div>
  );
};

export default MainLayout;
